import type { UnsubscribeResult, UnsubscribeResultResponse } from '../types';

export function mapUnsubscribeResult(data: UnsubscribeResultResponse): UnsubscribeResult {
  return {
    value: data.value,
    type: data.type,
    success: data.success,
    error: data.error ?? null,
  };
}
